<template>
    <div class="computerBox">
        <topBox :title="$route.meta.title" />
        <div class="px-[36px] w-full mt-[80px] pb-[70px]">

            <div class="rounded-[20px] border bg-white px-[20px] py-[12px] shadow-lg text-center mb-4">
                <div class="text-14 text-slate-400">{{ $t('text.withdrawRecordTotal') }}</div>
                <div class="mt-1 text-m14 font-semibold text-slate-900">{{ total }}</div>
            </div>

            <van-list
                v-model:loading="loading"
                :finished="finished"
                :immediate-check="true"
                :finished-text="$t('text.noMore')"
                @load="onLoad"
            >
                <div
                    v-for="item in list"
                    :key="item.withdraw_id"
                    class="record-item"
                >
                    <div class="flex items-center justify-between gap-3">
                        <div class="min-w-0">
                            <div class="text-m16 font-semibold text-slate-900">
                                ¥{{ item.amount }}
                                <span class="ml-2 fz12 font-normal text-slate-400">{{ typeLabel(item.type) }}</span>
                            </div>
                            <div class="mt-1 fz12 text-slate-400">
                                {{ $t('text.withdrawApplyTime') }}：{{ date(item.created_at) }} {{ time(item.created_at) }}
                            </div>
                            <div class="mt-1 fz12 text-slate-400">
                                {{ $t('text.withdrawMonth') }}：{{ item.month }}
                            </div>
                        </div>
                        <div class="shrink-0 fz12 font-semibold" :class="statusClass(item.status)">
                            {{ statusLabel(item.status) }}
                        </div>
                    </div>
                </div>
            </van-list>

            <div v-if="finished && list.length === 0" class="py-10 text-center text-sm text-slate-400">
                {{ $t('text.noWithdrawRecords') }}
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import format from '@/assets/js/formatDate'
import postPages from '@/assets/js/postPages'
import { layer } from 'vue3-layer'

export default {
    components: {
        topBox,
        mainMenu,
    },
    setup() {
        return {
            ...format(),
        }
    },
    data() {
        return {
            lang: '',
            list: [],
            total: 0,
            pageNumber: 1,
            pageSize: 20,
            loading: false,
            finished: false,
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
    },
    methods: {
        typeLabel(type) {
            const map = {
                0: this.$t('text.withdrawTrx'),
                1: this.$t('text.withdrawUsdt'),
                3: this.$t('text.payAlipay'),
                4: this.$t('text.payWxpay'),
            }
            return map[type] || '-'
        },
        statusLabel(status) {
            const map = {
                0: this.$t('text.withdrawStatusPending'),
                1: this.$t('text.withdrawStatusSuccess'),
                2: this.$t('text.withdrawStatusFail'),
            }
            return map[status] || '-'
        },
        statusClass(status) {
            if (status === 1) return 'text-green-600'
            if (status === 2) return 'text-red-500'
            return 'text-amber-600'
        },
        onLoad() {
            const page = postPages(
                this.lang,
                localStorage.getItem('token'),
                '/api/m/page/withdraw',
                this.pageSize,
                this.pageNumber,
                ''
            )
            page.data.then((res) => {
                if (res && res.code === 0) {
                    const items = res.data.items || []
                    this.total = res.data.total || 0
                    items.forEach((item) => {
                        this.list.push(item)
                    })
                    this.loading = false
                    this.pageNumber++
                    if (this.list.length >= this.total) {
                        this.finished = true
                    }
                } else {
                    this.loading = false
                    this.finished = true
                    if (res) layer.msg(res.msg)
                }
            }).catch(() => {
                this.loading = false
                this.finished = true
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}

.record-item {
    padding: 14px 16px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.08);
}
</style>
